import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
import { faqs } from '../data/constants';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 px-4 max-w-4xl mx-auto" data-id="element-98">
      <div className="text-center mb-10 md:mb-14" data-id="element-99">
        <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3 flex items-center justify-center gap-2" data-id="element-100">
          <HelpCircle className="w-4 h-4" data-id="element-101" /> Preguntas frecuentes
        </p>
        <h2 className="text-2xl md:text-4xl font-extrabold leading-tight" data-id="element-102">
          Lo que más <span className="text-primary" data-id="element-103">nos preguntan</span>
        </h2>
      </div>

      <div className="space-y-3" data-id="element-104">
        {faqs.map((f, i) => {
        const isOpen = openIndex === i;
        return <div key={i} className={`rounded-2xl border overflow-hidden transition-colors duration-200 ${isOpen ? 'bg-surface border-primary/50 shadow-[0_0_20px_rgba(249,168,212,0.08)]' : 'bg-surface border-zinc-800 hover:border-primary/30'}`} data-id="element-105">
              <button className="w-full px-5 py-4 md:px-6 md:py-5 text-left flex items-center justify-between gap-4 focus:outline-none" onClick={() => setOpenIndex(isOpen ? null : i)} data-id="element-106">
                <span className="font-bold text-white text-sm md:text-base leading-snug" data-id="element-107">
                  {f.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-primary shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-108" />
              </button>

              <AnimatePresence data-id="element-109">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-110">
                    <div className="px-5 pb-5 md:px-6 md:pb-6 text-zinc-300 text-sm md:text-base leading-relaxed border-t border-primary/15 pt-4" data-id="element-111">
                      {f.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </section>;
}